import React, { useState, useEffect, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faEllipsis, faLink, faAnglesLeft, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import AssetsIcon from '../../../assets/images/oparation.svg';
import AssetsIconw from '../../../assets/images/oparation_a.svg';
import { Button, ProgressBar } from 'react-bootstrap';

import { Link } from 'react-router-dom';
import ActivityComments from '../../../Components/common/ActivityComments';
import ImageUpload from '../../../Components/common/ImageUpload';
import { AWBGRIDDETAILS, GETULDDETAILS, MVTHDETAILS, TRUCKAWBDETAILS } from '../../../Utils/conts';
import { withRFSToken } from '../../../Services/axios';

import Overview from './common/Overview';
import Attachments from './common/Attachments';
import History from './common/History';

const AwbDetails = ({ onBack }) => {
    const isMounted = useRef(false);
    const detailsData = JSON.parse(localStorage.getItem('OVDetails'))
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(detailsData || null);
    const [selectedButton, setSelectedButton] = useState('ov');
    const [sendData, setSendData] = useState();
    const [sendOvData, setSendOvData] = useState();


    // let storedData = localStorage.getItem('OVDetails');

    // if (storedData) {
    //     storedData = JSON.parse(storedData)
    // }
    const fetchAwbDetails = async (ddata) => {
        setIsLoading(true)
        try {
            const res = await withRFSToken.post('fsu-awb/details', { awb_no: ddata.ULD.awb_no ?? ddata.ULD.airway_bill })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const storageData = {
                        ...detailsData,
                        ULD: { ...detailsData.ULD, ...innerData },
                    };
                    // localStorage.setItem('OVDetails', JSON.stringify(storageData));
                    fetchDetails(storageData)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchDetails = async (awbill) => {
        let endPoint;
        if (detailsData.sec === 'D') {
            endPoint = AWBGRIDDETAILS;
        } else {
            endPoint = TRUCKAWBDETAILS;
        }
        try {
            const res = await withRFSToken.post(endPoint, { awb_id: awbill.ULD.awb_id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    // setFormData(innerData);
                    const storageData = {
                        ...awbill,
                        ULD: { ...awbill.ULD, ...innerData },
                    };
                    // setSelectedRowData(storageData);
                    setSendData(innerData)
                    setSendOvData(storageData)
                    localStorage.setItem('OVDetails', JSON.stringify(storageData));
                    setIsLoading(false)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }



    useEffect(() => {
        if (isMounted.current) return;

        fetchAwbDetails(detailsData);

        // fetchDetails(detailsData)

        isMounted.current = true;
    }, [])

    // useEffect(() => {
    //     setSelectedRowData(detailsData)
    // }, [detailsData])

    const loadDetails = async (awbill) => {
        try {
            const res = await withRFSToken.post(AWBGRIDDETAILS, { awb_id: awbill })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    setSelectedRowData(innerData);

                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleCloseClick = () => {
        setSelectedRowData(null);
    };

    const handleButtonClick = async (button) => { setSelectedButton(button) }

    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };



    return (
        <>
            {isLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            {/* {console.log('selectedRowData', selectedRowData)} */}
            {/* <div className="">
                <Header logo_url='/TruckMonitor' />
                <div className="schedule">
                    <LeftMenu /> */}
            <div className='main-panel'>
                <Link to='#' onClick={() => onBack()} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                <div className='maindiv'>
                    <div className='SecondDiv mt-3'>
                        {/* <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button> */}
                        <div className='girddtals_header'>
                            <h3>
                                {detailsData?.ULD.awb_no} &nbsp;
                                <span className='position-relative'>
                                    {
                                        detailsData?.ULD.pick_status && Array.isArray(detailsData?.pick_status) ?
                                            detailsData?.ULD.pick_status.map((item, index) =>
                                                <>
                                                    {/* <div class=""> */}
                                                    <div key={index} class={`mt-0 ${item.color_status}`} style={{ position: 'absolute', top: '1px', left: '0' }}>{item.status || ''}</div>
                                                    {/* </div> */}
                                                </>
                                            )
                                            : ''
                                    }
                                </span>
                            </h3>
                            <div className='d-flex actbtn'>

                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                            </div>

                        </div>
                        {/* <div className='d-flex justify-content-between my-3'>
                                    <div className='order_view'>
                                        <h3>{storedData.ULD.loading_station}</h3>
                                        <span>
                                            {storedData.ULD.loading_name && storedData.ULD.loading_name.length > 20
                                                ? `${storedData.ULD.loading_name.slice(0, 20)}...`
                                                : storedData.ULD.loading_name}
                                        </span>
                                        <div className='mt-3'>
                                            <p>Scheduled - <b>{storedData.ULD.loading_date_scheduled} <span></span></b> </p>
                                            <p>Actual - <b>{storedData.ULD.loading_date_actual} <span></span></b> </p>
                                        </div>
                                    </div>
                                    <div className='order_middle'>
                                        <p><img src={Cargotruck} /></p>
                                        <span>{storedData.ULD.truck_number}</span>
                                    </div>
                                    <div className='order_view'>
                                        <h3>{storedData.ULD.unloading_station}</h3>
                                        <span>
                                            {storedData.ULD.unloading_name && storedData.ULD.unloading_name.length > 20
                                                ? `${storedData.ULD.unloading_name.slice(0, 20)}...`
                                                : storedData.ULD.unloading_name}
                                        </span>
                                        <div className='mt-3'>
                                            <p>Scheduled - <b>{storedData.ULD.unloading_date_scheduled} <span></span></b> </p>
                                            <p>ETA - <b>{storedData.ULD.unloading_date_actual} <span></span></b> </p>
                                        </div>
                                    </div>
                                </div> */}
                        {/* <div className='d-flex justify-content-between rabord'>
                                    <div className='firstbrd'>
                                        <p>Boardpoint</p>
                                        <span>{storedData.ULD.loading_station}</span>
                                    </div>
                                    <div className='middlebrd'>
                                        <p>{storedData.ULD.loading_date_scheduled}</p>
                                        <p><img src={Cargotruck} /></p>
                                        <p>{storedData.ULD.unloading_date_scheduled}</p>
                                    </div>
                                    <div className='lastbrd'>
                                        <p>Offpoint</p>
                                        <span>{storedData.ULD.unloading_station}</span>
                                    </div>
                                </div>

                                <div className='d-flex justify-content-between rabord'>
                                    <div className='firstbrd'>
                                        <p>Origin</p>
                                        <span>AMS</span>
                                    </div>
                                    <div className='middlebrd'>
                                        <p>2025-01-01</p>
                                        <p><img src={Cargoplane} /></p>
                                        <p>LY-0083</p>
                                    </div>
                                    <div className='lastbrd'>
                                        <p>Destination</p>
                                        <span>BRU</span>
                                    </div>
                                </div> */}

                        {/* <div className='mb-3'>
                                    <ProgressBar animated now={50} style={{ height: "5px" }} />
                                </div> */}
                        <div className='movment_history mt-2'>
                            <h3>Status Updates</h3> {/*<Link to='#' onClick={movementHistoryClick}>View All</Link>*/}
                        </div>
                        {/* <div className='movement_list_wrap'>
                                    {storedData.ULD && storedData.ULD?.status_updates.map((history, index) => (
                                        <div className='movment_list_card d-flex justify-content-between align-items-center'>
                                            <div className='deli-dl d-flex'>
                                                <div className='deli-icon-wrap'>
                                                    <div className='deli-icon'>
                                                        <img src={pieces} alt="pieces" />
                                                    </div>
                                                </div>
                                                <div className='deli-dl-text'>
                                                    <h3>{history.status}</h3>
                                                    <h4>{history.date}&nbsp;&nbsp;&nbsp;&nbsp;{history.time}</h4>
                                                </div>
                                            </div>
                                            <div class="text-end"><span class="badge badge-ams">AMS</span></div>
                                        </div>
                                    ))}
                                </div> */}

                        <div className='movment_list'>
                            <ul>
                                {detailsData?.ULD?.status_updates?.map((history, index) => (
                                    <li key={`his_${index}`}>
                                        {/* <span className='movem w-auto'>{history.status}</span> */}
                                        <span className='movem w-auto'>{history.status_type} - {history.station}</span>
                                        <span className='mvdate'>{history.last_update}</span>
                                        {/* <Link to='#' >Details</Link>  */}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={detailsData.sec === 'D' ? 'awb_monitor' : 'rfs_awb'}
                            attachable_id={detailsData?.ULD.awb_id}
                            attachments={detailsData?.ULD.attachments}
                        // onDeleteSuccess={() => loadDetails(detailsData?.ULD.uld_number)}
                        />
                        <ActivityComments
                            commentable_type={detailsData.sec === 'D' ? 'awb_monitor' : 'rfs_awb'}
                            commentable_id={detailsData?.ULD.awb_id}
                            allactivities={detailsData?.ULD.activities}
                        // onReloadDetails={loadDetails}
                        />
                    </div>
                    <div className='trashdonload mt-3'>
                        <div className='d-flex justify-content-between mb-3'>
                            <div>
                                <button className={selectedButton === 'ov' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('ov')}>
                                    <img src={selectedButton === 'ov' ? AssetsIconw : AssetsIcon} /> <span>Overview</span>
                                </button>
                                <button className={selectedButton === 'at' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('at')}>
                                    <img src={selectedButton === 'at' ? AssetsIconw : AssetsIcon} /> <span>Attachments</span>
                                </button>
                                {/* <button className={selectedButton === 'hi' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('hi')}>
                                            <img src={selectedButton === 'hi' ? AssetsIconw : AssetsIcon} /> <span>History</span>
                                        </button> */}
                            </div>
                        </div>
                        <div
                            className={selectedButton === 'at' ? '' : 'bookinggrid flbg'}
                        >
                            {selectedButton === 'ov' && <Overview fData={sendOvData} />}
                            {selectedButton === 'at' && <Attachments fData={sendData} onLoad={() => fetchDetails(detailsData)} />}
                            {selectedButton === 'hi' && <History />}
                        </div>
                    </div>
                </div>
            </div>
            {/* </div>
            </div> */}
        </>
    )
}

export default AwbDetails